import type {TravelType} from '@/modules/common/context/QueryParams/models';
import type {Offer} from '@/redux/v1/offers/list/models';

export const FETCH_OFFER_UPSELLING =
  'redux/v1/offerUpselling/fetchOfferUpselling';

export type Query = {
  offerId: string;
  travelType: TravelType;
};

export type Upgrades = {
  roomUpgrade: Array<{
    description: Array<string>;
    attributes: Array<string>;
    boardType: Array<string>;
    roomType: Array<string>;
  }>;
  tourOperatorSpecials: Array<string>;
  transportations: Array<string>;
};

export type UpsellingOffer = Offer & {
  upgrades: Upgrades;
};

export type Status = 'idle' | 'loading' | 'successful' | 'failed';
export type Data = Array<UpsellingOffer>;

type StatusState = Record<string, Status>;
type ByQueryState = Record<string, Data>;
type ByOfferIdState = Record<string, UpsellingOffer>;
type ErrorsState = Record<string, null | Error>;

export type OfferUpsellingState = {
  status: StatusState;
  byQuery: ByQueryState;
  byOfferId: ByOfferIdState;
  errors: ErrorsState;
};
